/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_item = {
    readonly isAvailable: boolean | null;
    readonly isSold: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly hasActiveHoldForBuyer?: boolean | null;
    readonly " $refType": "PdpSharedDetailReference_item";
};
export type PdpSharedDetailReference_item$data = PdpSharedDetailReference_item;
export type PdpSharedDetailReference_item$key = {
    readonly " $data"?: PdpSharedDetailReference_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailReference_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isAvailable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPrivateListing",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasActiveHoldForBuyer",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '972022bbe3d1ef3b500ad2ed0ff57d82';
export default node;
